module.exports = __webpack_public_path__ + "img/ic_gift.48d567c4.png";